export default "__VITE_ASSET__BzsLkgNT__"